// project imports
import { getIriFromObj } from 'utils/processors';
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';

export const processEntityInput = (values) => ({ ...values, ...processEntityInputMain(values) });

const normalizeCoordinateOutput = (coordinate) => {
    if (coordinate === '' || coordinate === null || typeof coordinate === 'undefined') {
        return undefined;
    }

    const numericCoordinate = Number(coordinate);

    return Number.isFinite(numericCoordinate) ? numericCoordinate : undefined;
};

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    id: undefined,
    isBeingAdded: undefined,
    isBeingEdited: undefined,
    isBeingDeleted: undefined,
    province: undefined,
    latitude: 'latitude' in (values || {}) ? normalizeCoordinateOutput(values.latitude) : undefined,
    longitude: 'longitude' in (values || {}) ? normalizeCoordinateOutput(values.longitude) : undefined,
    municipality: 'municipality' in (values || {}) ? getIriFromObj(values.municipality) : undefined
});
